<header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <div class="navbar-header center">
            <img src="assets/images/Logo-Only.png" class="navbar-brand light-logo" alt="homepage" />
        </div>
        <div class="navbar-collapse">
            <div class="navbar-nav me-auto">
                <a class="nav-link nav-toggler hidden-md-up menulist" href="javascript:void(0)"
                    (click)="toggleMobileMenu()"><i class="bi bi-list"></i></a>
                <!-- <img src="assets/images/point-logo.svg" class="header-logo" alt="homepage"> -->
            </div>
            <ul class="navbar-nav my-lg-0">
                <li class="nav-item" style="margin-right: 50px;">
                    <app-multi-dropdown [control]="$any(userForm.get('year'))" [submitted]="submitted"
                        [placeholder]="'Select Year'" [errorMessage]="''" (change)="onChangeYear($event)"
                        [items]="schoolYearList" [labelProperty]="'year'" [valueProperty]="'year'" [multiple]="false"
                        [image]="false" [clearable]="false" [searchable]="false" [max]="3"></app-multi-dropdown>
                </li>
                <!-- <li class="nav-item notification-container">
                    <div class="nav-link bell-container">
                        <i class="bi bi-bell-fill icon-size"></i>
                        <div id="newNoti" class="noti-count">10</div>
                    </div>

                    <div>
                        <app-side-panel [template]="notificationList" [show]="show"></app-side-panel>
                    </div>
                </li> -->
                <li class="nav-item dropdown right-20">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark profile-pic" href="#" id="navbarDropdown"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="bg-profile" [ngClass]="'bg-outline-green'"><img src={{this.profileImageBase64}}
                                alt="user" class="img-profile"></div>
                        <span class="hidden-md-down profile-name">{{userDetail?.firstName + ' ' +
                            userDetail?.lastName}}
                            &nbsp;</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right drp-notification animated bounceInDown">
                        <ul class="dropdown-user">
                            <li>
                                <a [routerLink]="profileLink" routerLinkActive="active"
                                    class="profile-li font-12"><i class="bi bi-person"></i> My Profile</a>
                            </li>
                            <li class="role-switch-container" *ngIf="hasStaffRole">
                                <div class="role-switch">
                                    <button [ngClass]="isCheckedIn ? 'role-btn role-checkout-btn' : 'role-btn role-checkin-btn'" (click)="staffCheckIn()">
                                        <i class="bi" [ngClass]="isCheckedIn ? 'bi-calendar-x' : 'bi-calendar-check'"></i>
                                        {{ isCheckedIn ? 'Check Out' : 'Check In' }}
                                    </button>                                    
                                </div>
                            </li>
                            <li *ngIf="hasAdminAndParentRole" class="role-switch-container">
                                <div class="role-switch">
                                    <span class="role-label"><i class="bi bi-people"></i> Current Role:
                                        <strong>{{ currentRole }}</strong></span>
                                    <button class="role-toggle-btn" (click)="toggleRole()">Switch to {{ switchToRole }}</button>
                                </div>
                            </li>
                            <li class="role-switch-container" *ngIf="schoolList.length > 1">
                                <div class="role-switch">
                                    <span class="role-label"><i class="bi bi-arrow-left-right"></i> Switch School:</span>
                                    <select [(ngModel)]="selectedSchool" class="role-dropdown">
                                        <option *ngFor="let sch of schoolList" [value]="sch">{{ sch }}</option>
                                    </select>
                                    <button class="role-toggle-btn" (click)="applySelectedSchool()">Apply</button>
                                </div>
                            </li>
                            <li>
                                <a href="#" class="profile-li font-12"><i class="bi bi-key" (click)="signOut()"></i>
                                    Sign Out</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
    <div class="mobile-menu" *ngIf="isMobileMenuOpen">
        <ul *ngIf="isMobile">
            <li *ngFor="let item of mobileMenuItems">
                <!-- Menu Item -->
                <div class="menu-item-container" (click)="item.showSubmenu = !item.showSubmenu">
                    <img [src]="item.icon" class="menu-icon" alt="{{ item.name }} icon" />
                    <span class="menu-name">{{ item.name }}</span>
                    <i *ngIf="item.submenuitem" class="submenu-toggle-icon bi"
                        [ngClass]="{'bi-chevron-down': !item.showSubmenu, 'bi-chevron-up': item.showSubmenu}"></i>
                </div>
                <!-- Submenu -->
                <ul *ngIf="item.showSubmenu" class="submenu">
                    <li *ngFor="let sub of item.submenuitem" (click)="setActiveMenuItem(sub)">
                        <a>{{ sub.name }}</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</header>
<app-toastr [properties]="alertProperties" *ngIf="showAlert"></app-toastr>
<app-modal [template]="modalTemplate" [state]="modalState" [size]="modalSize"></app-modal>

<ng-template #notificationList>
    <div class="noti-spacer">
        <p class="noti-header">Notification</p>
    </div>
    <div class="noti-spacer close-noti-sidebar">
        <app-button [properties]="{name:'',function:'close'}" (click)="showPanel()"></app-button>
    </div>

    <div class="noti-tab-header">
        <div class="noti-spacer">
            <span id="allNoti" class="listing-filter-btn active-btn noti-tab" (click)="activeTab('allNoti');">All
                Notification <span>100</span></span>
        </div>
        <div class="noti-spacer">
            <span id="unreadNoti" class="listing-filter-btn" (click)="activeTab('unreadNoti')">Unread
                <span>40</span></span>
        </div>
        <div class="noti-spacer">
            <span id="readNoti" class="listing-filter-btn" (click)="activeTab('readNoti')">Read<span>60</span></span>
        </div>
    </div>

    <div class="noti-item-container noti-all-empty" *ngIf="notiStateEmptyOrNot">
        <ng-container *ngTemplateOutlet="emptyStateNoti"></ng-container>
    </div>
    <div class="noti-item-container">
        <div class="footer-noti-container">
            <app-button [properties]='{ name: "Close", type: "light non-capitalized"}'
                (click)="showPanel()"></app-button>
        </div>
    </div>
</ng-template>

<ng-template #emptyStateNoti>
    <img src="assets\images\Empty-States.png" alt="">
    <p class="empty-state-noti-font">No Unread Notification Yet</p>
</ng-template>
<app-spinner [state]="loading"></app-spinner>
